export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
  highlight: string
  photo?: string
}

/** Los 4 primeros se muestran siempre. */
export const featuredTestimonials: Testimonial[] = [
  {
    name: 'Carolina M.',
    role: 'Gerente de proyectos',
    location: 'Ciudad de México',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/42ff2682-8bec-4b1a-a3d1-4ea687d8d32a.jpg',
    quote:
      'Llevaba años con el bajón de las 4 de la tarde. Cambié el orden de mi almuerzo y a la semana ya no buscaba el chocolate del cajón. Sigo comiendo lo mismo, literal.',
    highlight: 'Sin antojo a las 4 PM',
  },
  {
    name: 'Valentina R.',
    role: 'Contadora',
    location: 'Bogotá',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0893a126-d383-4071-bb8a-ab473b9fa98d.jpg',
    quote:
      'Lo que más me sorprendió fue dormir de corrido. Antes despertaba a las 3 AM sin razón. Tres semanas aplicando la secuencia y eso desapareció.',
    highlight: 'Duerme de corrido',
  },
  {
    name: 'Daniela S.',
    role: 'Diseñadora, 2 hijos',
    location: 'Buenos Aires',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/374ccc4b-7154-4261-a76f-6eff7b744d71.jpg',
    quote:
      'Probé de todo: keto, ayuno, contar macros. Todo me duraba tres semanas. Esto es lo único que pude sostener porque no tengo que renunciar a nada.',
    highlight: 'Por fin algo sostenible',
  },
  {
    name: 'Mariela T.',
    role: 'Abogada',
    location: 'Santiago',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/4f0ea2d4-3bef-4f76-acae-2a5376c6289e.jpg',
    quote:
      'Como fuera de casa casi todos los días por trabajo. El guion para restaurantes fue lo que me cambió el juego: ya sé exactamente qué pedir primero.',
    highlight: 'Funciona comiendo fuera',
  },
]

/** Se despliegan al pulsar "Ver más testimonios". */
export const moreTestimonials: Testimonial[] = [
  {
    name: 'Paula G.',
    role: 'Enfermera, turnos rotativos',
    location: 'Lima',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/18ad30d3-b1c5-48df-a118-28bbb774a408.jpg',
    quote:
      'Con turnos de noche vivía a base de café y galletas. Aplicando el orden en la primera comida del turno dejé de tener el hambre desesperada de las 3 de la mañana.',
    highlight: 'Turnos nocturnos',
  },
  {
    name: 'Rocío A.',
    role: 'Profesora',
    location: 'Guadalajara',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/08b52f97-e698-413e-adb3-9df7295fcaf6.jpg',
    quote:
      'Antes llegaba a casa y arrasaba con la despensa. Ahora ceno tranquila y no vuelvo a la cocina. Esa sola cosa me cambió las noches.',
    highlight: 'Adiós atracón nocturno',
  },
  {
    name: 'Fernanda L.',
    role: 'Ejecutiva de ventas',
    location: 'Monterrey',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/3f5ebe48-f59e-4ef0-a3a5-bbaf99eb52d7.jpg',
    quote:
      'Mis reuniones son con comida siempre. Me quité la culpa: como lo mismo que los demás, solo empiezo por otro lado del plato.',
    highlight: 'Cero culpa social',
  },
  {
    name: 'Andrea C.',
    role: 'Emprendedora',
    location: 'Medellín',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/cfb8fbe7-ca8e-4a58-999b-a6b1f7e2ef09.jpg',
    quote:
      'En 21 días bajé 3 kilos sin contar una sola caloría. Pero lo mejor fue la panza: dejé de sentirme inflamada todo el día.',
    highlight: 'Menos inflamación',
  },
  {
    name: 'Luciana P.',
    role: 'Arquitecta',
    location: 'Córdoba',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/c60f0f65-2658-4814-8d33-104364bf1dd6.jpg',
    quote:
      'Soy de las que se marean si pasan mucho tiempo sin comer. Con la secuencia aguanto la mañana entera trabajando sin ese temblor.',
    highlight: 'Energía sostenida',
  },
  {
    name: 'Gabriela N.',
    role: 'Community manager',
    location: 'Quito',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b0333b58-55c7-440a-adc4-94cf59ffb574.jpg',
    quote:
      'Lo apliqué medio escéptica porque era demasiado simple. A los cuatro días mi esposo me preguntó por qué ya no pedía postre.',
    highlight: 'Resultados en días',
  },
  {
    name: 'Sofía B.',
    role: 'Odontóloga',
    location: 'Asunción',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/2551da04-1652-4fb0-9590-6a00fbd96fab.jpg',
    quote:
      'El módulo del ciclo menstrual me voló la cabeza. Mi semana premenstrual era descontrol total y ahora sé exactamente qué ajustar.',
    highlight: 'Semana premenstrual',
  },
  {
    name: 'Camila V.',
    role: 'Ingeniera de sistemas',
    location: 'Santiago',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1a995430-3438-4598-be32-2a9596130f47.jpg',
    quote:
      'Trabajo frente a la pantalla 10 horas. La niebla mental de la tarde era mi normal. Ya no existe y no cambié ni un alimento.',
    highlight: 'Claridad mental',
  },
  {
    name: 'Natalia O.',
    role: 'Recursos humanos',
    location: 'Ciudad de México',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/f892cb40-a010-454d-9116-09053be4a74e.jpg',
    quote:
      'Lo que me convenció fue no tener que cocinar distinto para mí y para mi familia. Mismo plato, otro orden. Fin del problema.',
    highlight: 'Sin cocinar aparte',
  },
  {
    name: 'Verónica D.',
    role: 'Fotógrafa',
    location: 'Lima',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/c4a6324a-2db6-4fa2-bb34-e39e980ed79d.jpg',
    quote:
      'La guía visual la tengo pegada en el refri. Mis hijas ya saben qué se come primero. Se volvió costumbre de la casa.',
    highlight: 'Fácil de sostener',
  },
  {
    name: 'Ximena F.',
    role: 'Farmacéutica',
    location: 'Bogotá',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/5e2b8c71-7414-4bf7-9398-ebc3a064c29b.jpg',
    quote:
      'Tengo resistencia a la insulina diagnosticada. Con el visto bueno de mi médica lo apliqué y mis mediciones de la tarde mejoraron notablemente.',
    highlight: 'Mejores mediciones',
  },
  {
    name: 'Julieta S.',
    role: 'Periodista',
    location: 'Montevideo',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/4f447470-2568-4802-9996-dede2b1ca7e3.jpg',
    quote:
      'Pensé que iba a ser otro PDF de 80 páginas sin sustancia. Se lee en una tarde y se aplica en la cena de esa misma noche.',
    highlight: 'Aplicable el mismo día',
  },
  {
    name: 'Alejandra R.',
    role: 'Coordinadora logística',
    location: 'Panamá',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a8769b96-d987-472d-922a-e83de99272ed.jpg',
    quote:
      'El checklist de freno de emergencia me salvó varias veces. Antes el antojo me ganaba siempre; ahora tengo qué hacer en el momento.',
    highlight: 'Antojo bajo control',
  },
  {
    name: 'Patricia H.',
    role: 'Consultora',
    location: 'San José',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/f853653c-3f89-4863-aa3d-b2b0f466c4ac.jpg',
    quote:
      'Viajo dos semanas al mes. Es el primer método que no se me rompe en el aeropuerto ni en los hoteles.',
    highlight: 'Funciona viajando',
  },
  {
    name: 'Marcela Q.',
    role: 'Psicóloga',
    location: 'Buenos Aires',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0aa414f-0cc3-4af7-bbeb-63d19b959809.jpg',
    quote:
      'Como profesional de salud mental valoro que no culpabiliza. Explica la biología y te saca del “me falta voluntad”.',
    highlight: 'Sin culpa',
  },
  {
    name: 'Isabel T.',
    role: 'Docente universitaria',
    location: 'Santo Domingo',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0c961fce-02c5-4ce9-8ac4-3a22659acebe.jpg',
    quote:
      'A mis 44 pensaba que el cansancio era la edad. Resulta que era mi glucosa en montaña rusa todo el día.',
    highlight: 'Más de 40',
  },
  {
    name: 'Lorena E.',
    role: 'Diseñadora de interiores',
    location: 'Guayaquil',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b9afe747-9263-45c0-9f1b-527604c8efa9.jpg',
    quote:
      'Vegetariana desde hace 12 años y funcionó igual. Solo tuve que ordenar distinto lo que ya comía.',
    highlight: 'Apto vegetariana',
  },
  {
    name: 'Silvia J.',
    role: 'Administradora',
    location: 'La Paz',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/d8c94ce9-a6ab-4a28-bbb2-4fc244fc7015.jpg',
    quote:
      'Lo compré por curiosidad y a los dos meses mi hermana y dos compañeras del trabajo lo están aplicando por lo que vieron en mí.',
    highlight: 'Cambio visible',
  },
]

export const allTestimonialsCount = featuredTestimonials.length + moreTestimonials.length
